import { makeStyles } from '@mui/styles';
import theme from 'src/style-system/theme';

export const useStyles = makeStyles({
  mainContainer: {
    backgroundColor: theme.palette.whitePepper.main,
    padding: '50px 50px 60px',
  },

  contentContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    rowGap: '50px',
  },

  content: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: '30px',

    [theme.breakpoints.up('md')]: {
      columnGap: '60px',
    },
  },

  imgWrapper: {
    flexShrink: '0',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '250px',
    height: '250px',
    marginBottom: '10px',
    [theme.breakpoints.up(750)]: {
      marginBottom: '0px',
    },

    [theme.breakpoints.up('md')]: {
      width: '300px',
      height: '250px',
    },
  },

  titleContentWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    rowGap: '20px',
    maxWidth: '770px',

    [theme.breakpoints.up(750)]: {
      flexDirection: 'row',
      columnGap: '25px',
      alignItems: 'flex-start',
    },

    [theme.breakpoints.up('lg')]: {
      maxWidth: '655px',
    },

    [theme.breakpoints.up('xl')]: {
      maxWidth: '770px',
    },
  },

  title: {
    display: 'flex',
    flexDirection: 'column',
    rowGap: '15px',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: '25px',
    [theme.breakpoints.up(750)]: {
      alignItems: 'flex-start',
    },
  },

  id: {
    flexShrink: '0',
    fontSize: '18px',
    lineHeight: '24px',
    width: '40px',
    height: '40px',
    padding: '8px 10px',
    borderRadius: '50%',
    backgroundColor: theme.palette.turmeric.main,
    [theme.breakpoints.up(750)]: {
      fontSize: '24px',
      lineHeight: '32px',
      padding: '10px 15px',
      width: '50px',
      height: '50px',
    },
  },

  // for logo image

  superTastyLogo: {
    width: '120px',
    zIndex: 10,
    position: 'absolute',
    top: '-25px',
    left: '20px',
    animation: `$spin 5s linear infinite`,
    [theme.breakpoints.up(750)]: {
      top: '-25px',
      left: '5px',
    },
  },

  realRecipesLogo: {
    width: '65px',
    height: '65px',
    zIndex: 10,
    position: 'absolute',
    top: '170px',
    right: '-18px',
    animation: `$scale 2s linear infinite alternate`,
    [theme.breakpoints.up(750)]: {
      width: '75px',
      height: '75px',
      top: '160px',
      right: '-10px',
    },
  },

  '@keyframes spin': {
    '0%': { transform: 'rotate(0deg)' },
    '100%': { transform: 'rotate(360deg)' },
  },

  MoneySavingLogo: {
    width: '120px',
    zIndex: 10,
    position: 'absolute',
    top: '100px',
    left: '5px',
    animation: `$scale 2s linear infinite alternate`,
    [theme.breakpoints.up(750)]: {
      top: '100px',
      left: '30px',
    },
  },

  '@keyframes scale': {
    '0%': { transform: 'scale(1)' },
    '100%': { transform: 'scale(1.2)' },
  },
});
